<script lang="ts">
  import type { FacetValueLabel, FacetValueLabelOptions } from "./type";

  interface Props extends FacetValueLabel, FacetValueLabelOptions {}

  let { title, itemCount, size = "100", bold, showCount = true, logo }: Props = $props();

  itemCount = showCount ? itemCount : undefined;

  const logoWidthMap: Record<string, string> = {
    "50": "1.5rem",
    "75": "2rem",
    "100": "2.5rem",
    "125": "3rem",
  };

  const logoWidth = $derived(logoWidthMap[size] ?? "2.5rem");
</script>

<span class={["hc_label", `hc_label--${size}`]} data-count={itemCount}
  ><span class={["hc_label__title", { "hc_label__title--bold": bold }]}>
    {title}
  </span>
  <span class="hc_label__logo" style="--logo-width: {logoWidth}">
    <oc-logo-v1 {logo} fill-parent=""></oc-logo-v1>
  </span>
</span>

<style lang="scss">
  .hc_label {
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: var(--oc-semantic-spacing-50);
    overflow: hidden;
    font: var(--label-font);

    &--50 {
      --label-font: var(--oc-semantic-font-copy-50);
    }

    &--75 {
      --label-font: var(--oc-semantic-font-copy-75);
    }

    &--100 {
      --label-font: var(--oc-semantic-font-copy-100);
    }

    &--125 {
      --label-font: var(--oc-semantic-font-copy-125);
    }

    &--grow {
      justify-content: space-between;
      width: 100vw; /*                           */
    }

    &--margin-left {
      margin-left: var(--oc-semantic-spacing-50);
    }

    &__title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 0 1 min-content;

      &--bold {
        font-weight: 700;
      }
    }

    &[data-count]::after {
      flex: 0 0 max-content;
      color: var(--oc-semantic-color-text-secondary);
    }

    &:not(&--grow)[data-count]::after {
      content: "(" attr(data-count) ")";
    }

    &--grow[data-count]::after {
      content: attr(data-count);
    }

    &__logo {
      display: flex;
      align-items: center;
      width: var(--logo-width, 2.5rem);
    }
  }
</style>
